var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('t-select',{attrs:{"name":"timezone-selector","options":_vm.timezone_options},on:{"change":_vm.onTimezoneChanged},model:{value:(_vm.selected_timezone),callback:function ($$v) {_vm.selected_timezone=$$v},expression:"selected_timezone"}})}
var staticRenderFns = []

export { render, staticRenderFns }